import { render, staticRenderFns } from "./LockerInventory.vue?vue&type=template&id=36f5c5fa"
import script from "./LockerInventory?vue&type=script&lang=js&external"
export * from "./LockerInventory?vue&type=script&lang=js&external"
import style0 from "./LockerInventory.vue?vue&type=style&index=0&id=36f5c5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports